import { render, staticRenderFns } from "./VacancyEdit.vue?vue&type=template&id=f8a27ecc"
import script from "./VacancyEdit.vue?vue&type=script&lang=js"
export * from "./VacancyEdit.vue?vue&type=script&lang=js"
import style0 from "./VacancyEdit.vue?vue&type=style&index=0&id=f8a27ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports